import React from "react";
import SectionHeader from "./SectionHeader";
import RadioButton from "./../common/RadioButton";

function NotificationsSection() {
  return (
    <section className="mt-6 w-full max-md:max-w-full">
      <SectionHeader icon="notification" title="Notifications" />
      <div className="mt-4 w-full max-md:max-w-full">
        <h3 className="text-base font-medium leading-7 text-gray-700 max-md:max-w-full">
          Watched folders:
        </h3>
        <div className="mt-3 w-full max-md:max-w-full">
          <RadioButton label="no notifications" name="notifications" />
          <RadioButton label="daily" name="notifications" className="mt-2" />
          <RadioButton label="weekly" name="notifications" className="mt-2" />
          <RadioButton label="monthly" name="notifications" className="mt-2" />
        </div>
        <p className="mt-3 text-xs text-zinc-600 max-md:max-w-full">
          The frequency at which you would like to receive email notifications
          for watched folders.
        </p>
      </div>
    </section>
  );
}

export default NotificationsSection;
